import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class SubscribersService {
    constructor(private http: HttpClient) { }

    addSubscriber(params) {
        return this.http.post<any[]>(`${environment.apiUrl}/subscribers/add`, params);
    }

}